module.exports = __webpack_public_path__ + "img/boss.9809348c.png";